import { type ClassValue, clsx } from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Renders text with **bold** markdown syntax as React elements.
 * Safely converts **text** to React <strong> elements without using dangerouslySetInnerHTML.
 */
export function renderMarkdownText(text: string): React.ReactNode {
    // Split text by **bold** patterns
    const parts = text.split(/(\*\*.*?\*\*)/g);

    return parts.map((part, index) => {
        // Check if this part is bold (wrapped in **)
        if (part.startsWith('**') && part.endsWith('**')) {
            // Remove the ** and render as bold
            const boldText = part.slice(2, -2);
            return React.createElement('strong', { key: index }, boldText);
        }
        // Regular text
        return part;
    });
}
